import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  height: 70vh;
  // height: 75vh;
  overflow: auto;
  position: relative;
  // border: 2px solid red;
  // padding: 10px 0px;
`

export const DocInfoCont = styled.div`
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-template-columns: 2fr;
  padding: 10px;
  // border: 1px solid pink;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const DocInfoCard = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  // transition: box-shadow 0.3s ease;
  gap: 20px;
  margin: 10px 0px;

  &:hover {
    // box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
    
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
     padding: 5px;
  }
`

export const DeptName = styled.div`
  padding: 5px;
  font-size: 14px;
  color: #555;
`

export const AvblContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  border: 1px solid transparent;
  padding: 0px 20px;
//   width: 35%;
  max-width: 60%;
//   text-align: center;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

// *******************************

export const BookingContainer = styled.div`
  text-align: center;
  margin: 20px;
`

interface DateButtonProps {
  selected: any
}

export const DateButton = styled.button<DateButtonProps>`
  background-color: ${props => (props.selected ? '#00796b' :'#fff')};
  color: ${props => (props.selected ? '#fff' : '#00796b')};
  border: 1px solid #00796b;
  padding: 10px;
  border-radius: 5px;
  margin: 5px;
  font-size: 18px;
  cursor: pointer;
  width: 60px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${props => (props.selected ? '#004d40' : '#e0f2f1')};
  }
`

export const ContinueButton = styled.button`
  background-color: #00796b;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #004d40;
  }
`;

// **********************************************

export const SidebarSection = styled.div`
  // width: 30%;
  width: 520px;
  position: sticky;
  top: 0;
  right: 0;
  padding: 10px;
  border-right: 1px solid #ccc;
  border: 1px solid #ccc;
  border-radius: 10px;
`

export const AssistanceBox = styled.div`
  border: 1px solid #dfd8d8;
  border-radius: 10px;
  padding: 10px 15px;
  background-color: #c5f9f07a;
`

export const AssistanceText = styled.div`
  color: #606060;
  margin: 5px 0;
  font-size: 13px;
`

export const AssistanceTitle = styled.div`
  color: #009a85;
  margin: 5px 0;
  font-size: 15px;
  font-weight: 600;
`

export const ContactNumber = styled.div`
  margin: 10px 0;
  color: #009a85;
  font-size: 13px;
  border: 1px solid #009a85;
  padding: 5px 8px;
  border-radius: 5px;
  max-width: fit-content;
`

export const TipsContainer = styled.div`
  padding:  10px 15px 5px 15px;
  margin-top: 10px;
  background-color: #d7d5d552;
  border-radius: 10px;
  max-height: 100%;
  overflow-y: scroll;

  /* Custom scrollbar for WebKit browsers (Chrome, Edge, Safari) */
  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background: transparent !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: grey !important;
    border-radius: 10px !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #b0b0b0 !important; /* Lighter grey on hover */
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #cdcdcd transparent;
  border-radius: 10px;
`;

export const TipsHeading = styled.div`
  color: #606060;
  // padding: 5px 0;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
`

export const TipCard = styled.div`
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  margin: 5px 0;
`;

export const TipContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TipTextContainer = styled.div`
  padding: 5px;
`

export const TipHeading = styled.div`
  // padding: 5px 0;
  color: black;
  font-size: 15px;
  font-weight: 600;
`

export const TipSubHeading = styled.div`
  padding: 5px 0;
  color: grey;
  font-size: 13px;
`

export const ReadNowButton = styled.div`
  color: white;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 5px;
  background-color: #184a84;
  cursor: pointer;
  width: max-content;
`

// ********************************************************

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  border: 1px solid transparent;
  padding: 0px 20px;
  max-width: 60%;
`

export const SpecialityName = styled.div`
  font-weight: 600;
  font-size: 15px;
  color: black;
`

export const SpecialityDesc = styled.div`
  font-size: 13px;
  color: #777;
`

// ******************************************************

export const DateContainer = styled.div`
  display: flex;
  // justify-content: space-between;
  // max-width: 700px;
  // margin: 0px 5px;
  padding: 10px;
  width: 100%;
`

export const DateBox = styled.div`
  border: 1px solid #00bfa5;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.3s ease;
  margin: 0px 3px;
`

export const Day = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
`

export const DayOfWeek = styled.div`
  font-size: 1rem;
  color: #00796b;
`

export const NavigationButton = styled.button`
  padding: 10px;
  margin: 10px;
  background-color: #00796b;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`

export const TimeContainer = styled.div`
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;
  padding: 10px 0px;
`

interface TimeButtonProps {
  selected: any
}

export const TimeButton = styled.button<TimeButtonProps>`
    background-color: ${props => (props.selected ? '#00796b' : '#fff')};
    color: ${props => (props.selected ? '#fff' : '#00796b')};
    border: 1px solid #00796b;
    padding: 5px;
    border-radius: 5px;
    margin: 5px;
    font-size: 15px;
    cursor: pointer;
    width: 80px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${props => (props.selected ? '#004d40' : '#e0f2f1')};
    }
`

export const ContunueBookingButton = styled.div`
  color: white;
  font-size: 15px;
  padding: 8px 10px;
  border-radius: 5px;
  background-color: #009a85;
  cursor: pointer;
  width: max-content;
`